<template>
	<div>
		<div v-if="emptyOption">
			<b-form-checkbox
				v-model="empty"
				:disabled="disabled"
				@change="emptyChanged"
			>
				{{ emptyOption.label }}
			</b-form-checkbox>
		</div>
		<b-form-checkbox-group
			v-model="selected"
			:options="options"
			:disabled="disabled"
			stacked
			@change="selectedChanged"
		/>
	</div>
</template>

<script>
export default {

	props: {
		value: {
			type: Array,
			required: false,
		},
		options: {
			type: Array,
			required: true,
		},
		initialEmpty: {
			type: Boolean,
			required: false,
			default: false,
		},
		emptyOption: {
			type: Object,
			required: false,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		}
	},

	data ()
	{
		return {
			selected: this.value || [],
			empty: this.initialEmpty ? true : undefined,
		};
	},

	methods: {
		emptyChanged (checked)
		{
			if (checked)
			{
				this.selected = [];
			}

			this.emitChangeEvent();
		},
		selectedChanged (selected)
		{
			if (selected.length > 0)
			{
				this.empty = false;
			}

			this.emitChangeEvent();
		},
		emitChangeEvent ()
		{
			if (this.selected.length > 0)
			{
				this.$emit('input', this.selected);
				return;
			}
			else
			{
				if (this.emptyOption && this.empty)
				{
					this.$emit('input', this.emptyOption.value);
					return;
				}
			}

			this.$emit('input', undefined);
		},
	}
}
</script>